import { useTranslation } from "@opendash/i18n";
import { Form, TreeSelect } from "antd";
import React, { useEffect, useState } from "react";
import { useSourceTreeSelectData } from "../../../../../_shared";
import FormItemProps from "../../../types/FormItemProps";

export default (props: FormItemProps) => {
  const t = useTranslation();
  const treeData = useSourceTreeSelectData();
  const [defaultValue, setDefaultValue] = useState<string[]>(undefined);

  useEffect(() => {
    async function getSources() {
      const sources = await props.editItem?.sources?.query().find();
      setDefaultValue(sources?.map((source) => source.id));
    }
    if (props.editItem) getSources();
    else setDefaultValue([]);
  }, [props.editItem]);

  return (
    <>
      {defaultValue !== undefined && (
        <Form.Item
          label={t("maintenance:items.create.form.source.label")}
          name="source"
          initialValue={defaultValue}
        >
          <TreeSelect
            showSearch
            multiple
            style={{ width: "100%" }}
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            allowClear
            treeDefaultExpandAll
            treeData={treeData}
            treeNodeFilterProp="title"
          />
        </Form.Item>
      )}
    </>
  );
};
